import dayjs from 'dayjs';
import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';
import { BusinessModuleRef } from './business-module-ref.js';

export class PromoterEventSubscription extends DataModel {
  static readonly TYPE_ID: string = 'e061da24351246efaa161f5452094f9b';

  constructor(
        public readonly eventId: string,
        public readonly creatorId: string,
        public readonly creationDate: dayjs.Dayjs,
        public readonly businessRef: BusinessModuleRef,
  ) {
    super();
  }

  get $typeId(): string {
    return PromoterEventSubscription.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PromoterEventSubscription {
    return new PromoterEventSubscription(
        MapUtils.get<string>(map, 'eventId'),
        MapUtils.get<string>(map, 'creatorId'),
        context.decodeDate(MapUtils.get<number>(map, 'creationDate')),
        BusinessModuleRef.mustDecode(MapUtils.get<string>(map, 'businessRef')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'eventId': this.eventId,
      'creatorId': this.creatorId,
      'creationDate': context.encodeDate(this.creationDate),
      'businessRef': this.businessRef.encode(),
    };
  }

  clone(): this {
    return new PromoterEventSubscription(
        this.eventId,
        this.creatorId,
        this.creationDate,
        this.businessRef.clone()
    ) as this;
  }

  isSame(other: PromoterEventSubscription): boolean {
    if(this === other) {
      return true;
    }

    return other.eventId === this.eventId &&
          other.creatorId === this.creatorId &&
          other.creationDate === this.creationDate &&
          other.businessRef === this.businessRef;
  }
}

export class PromoterEventSubscriptionBuilder extends DataModelBuilder<PromoterEventSubscription> {
  build(context: SerializationContext, map: SerializedData): PromoterEventSubscription {
    return PromoterEventSubscription.fromMap(context, map);
  }
}
